import { initializeAccountPortalState } from "../state/reducers.js";
import "../state/actions.js";
import { beforeAuthenticationSuccess } from "../state/utils.js";
import { getReduxStore } from "../store/state/redux-host.js";
import "../store/state/host.js";
import "../store/state/modal.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import { getAuthentication } from "./state-getters.js";
function onceAuthenticated(listener, { ignoreSessionReload = false, ignoreReAuthentication = false } = {}) {
  initializeAccountPortalState();
  const currentAuth = getAuthentication();
  if (currentAuth.isAuthenticated && currentAuth.isExternalAuth) {
    listener(currentAuth);
    return () => {
    };
  }
  const store = getReduxStore();
  const unsubscribe = store.subscribe(() => {
    const authInfo = getAuthentication();
    const reAuthenticationIgnored = ignoreReAuthentication && authInfo.isReauthenticated;
    const sessionReloadIgnored = ignoreSessionReload && authInfo.isSessionReload;
    if (!authInfo.isAuthenticated || reAuthenticationIgnored || sessionReloadIgnored) {
      return;
    }
    unsubscribe();
    listener(authInfo);
  });
  return unsubscribe;
}
function onceAuthenticationRevoked(listener) {
  initializeAccountPortalState();
  const store = getReduxStore();
  const unsubscribe = store.subscribe(() => {
    const { isAuthenticated } = getAuthentication();
    if (isAuthenticated !== false) {
      return;
    }
    unsubscribe();
    listener();
  });
  return unsubscribe;
}
function onceAuthenticationFailed(listener) {
  initializeAccountPortalState();
  const store = getReduxStore();
  const unsubscribe = store.subscribe(() => {
    const { isSessionReload, isPending, error } = getAuthentication();
    if (isSessionReload) {
      return;
    }
    if (isPending && error) {
      unsubscribe();
      listener(error);
    }
  });
  return unsubscribe;
}
function onBeforeAuthenticationSuccess(listener) {
  return beforeAuthenticationSuccess.on(listener);
}
function onceBeforeAuthenticationSuccess(listener) {
  return beforeAuthenticationSuccess.once(listener);
}
export {
  onBeforeAuthenticationSuccess,
  onceAuthenticated,
  onceAuthenticationFailed,
  onceAuthenticationRevoked,
  onceBeforeAuthenticationSuccess
};
//# sourceMappingURL=state-events.js.map
